function ErrorFallback(errors) {
  return <h2 style={{width:"100%", textAlign:"center"}}>Sorry! Not able to get the blogs.</h2>;
}

export default ErrorFallback;
